import TreePointsMoreIcon from "@assets/icons/Generals/TreePointsMoreIcon"
import { columnsOrderedTable } from "@thelpers/columnsTableHelper"
import CustomDropdown from "@UI/CustomDropdown"
import { dropdownCollectionAdministrationItems } from "./dropdownItems"

export const columnsDetailCollectionTableHelper = ({
    columns = [],
    chargeInstanceId,
    onUpdateAmount,
    onExtraordinaryPayment,
    handleRedirectTo,
    onExonerate,
    isDelete
}) => {

    const defaultColumns = [
        {
            title: 'Espacio',
            dataIndex: 'place_name',
            key: 'place_name',
        },
        {
            title: 'Pagante',
            dataIndex: 'debtor_name',
            key: 'debtor_name',
        },
        {
            title: 'Status',
            dataIndex: 'status_name',
            key: 'status_name',
            render: (_, record) => {
                return (
                    <span
                        className="collection-administration-table-status"
                        style={{ backgroundColor: record?.status_color ?? 'var(--successminus3)', color: '#1A1A1A' }}
                    >
                        {record.status_name}
                    </span>
                )
            }
        },
        {
            dataIndex: "late_fee_value",
            key: "late_fee_value",
            title: "Mora"
        },
        {
            dataIndex: "total",
            key: "total",
            title: "Total"
        },
        {
            dataIndex: "payment_type_name",
            key: "payment_type_name",
            title: "Tipo de pago"
        },
        {
            title: "Acción",
            width: '75px',
            render: (_, record) => {
                return (
                    <div className="collection-administration-table-action">
                        <CustomDropdown
                            overlayClassName="received-payment-detail-dropdown"
                            placement="left"
                            typeShowMenu='click'
                            items={dropdownCollectionAdministrationItems({
                                isDelete,
                                record,
                                chargeInstanceId,
                                handleRedirectTo,
                                status: record.charge_status_code,                               
                                onUpdateAmount,
                                onExtraordinaryPayment,
                                onExonerate
                            })}
                            styleMenu={{ width: 150 }}
                        >
                            <div>
                                <TreePointsMoreIcon color="#A4A4A4" />
                            </div>
                        </CustomDropdown>
                    </div>
                )
            }
        },
    ]

    return columns.length ? columnsOrderedTable({
        defaultColumns,
        backendColumns: columns,
        titleUpperCase: true,
        ignoreColumns: ['charge_status_code']
    }) : defaultColumns
}

export const columnsDetailCollectionTableFilters = ({ currentParams }) => {
    const sort_order = currentParams?.sort_order === 'desc' ? 'descend' : 'ascend'

    return {
        place_name: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'place_name' ? sort_order : null,
        }),
        debtor_name: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'debtor_name' ? sort_order : null,
        }),
        status_name: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'status_name' ? sort_order : null,
        }),
        late_fee_value: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'late_fee_value' ? sort_order : null,
        }),
        total: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'total' ? sort_order : null,
        }),
        default: () => ({}),
    }
}